export default __webpack_public_path__ + "static/media/activity-trash.78b16602.svg";